import styled from "styled-components";
import { Button } from "../button/Button.styled";
export const Wrapper = styled.div `
  display: inline-flex;
  flex-flow: row wrap;
  flex: 1 0 0;
  padding: 0;
  max-height: 100%;
`;
export const HiddenWrap = styled.div `
  visibility: hidden;
  pointer-events: none;
  height: 0;
`;
export const OverflowWrapper = styled.div `
  ${({ showOverflow }) => showOverflow
    ? ""
    : `
        visibility: hidden;
        pointer-events: none;
    `};
  position: relative;
`;
export const DefaultOverflowWrapper = styled.div `
  display: flex;
  flex-direction: column;

  ${Button} {
    border-radius: 0;
  }
`;
